import React from "react";
import { Helmet } from "react-helmet-async";
import "./stars.scss";
import Typed from "react-typed";

class Intro extends React.Component {
  render() {
    return (
      <div id="home" className="intro route bg-image background">
        {/* SEO Meta Tags */}
        <Helmet>
          <title>Ethervue - Embracing Excellence Through Innovation</title>
          <meta name="description" content="Ethervue Private Limited pioneers innovation with cutting-edge solutions in IT, GIS, AI, and decision science." />
          <meta name="keywords" content="Ethervue, IT Solutions, GIS, Decision Science, AI, Web Development, Data Science, Machine Learning" />
          <meta name="author" content="Ethervue" />

          {/* Open Graph for Social Media */}
          <meta property="og:title" content="Ethervue - Innovation and Excellence" />
          <meta property="og:description" content="Join Ethervue in pioneering innovation with top-tier IT and AI solutions." />
          <meta property="og:image" content="https://ethervue.in/img/ethervue-logo.png" />
          <meta property="og:url" content="https://ethervue.in" />
          <meta property="og:type" content="website" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Ethervue - Innovation and Excellence" />
          <meta name="twitter:description" content="Discover how Ethervue is driving innovation in AI, GIS, and IT solutions." />
          <meta name="twitter:image" content="https://ethervue.in/img/ethervue-logo.png" />
        </Helmet>

        <div id="stars" />
        <div id="stars2" />
        <div id="stars3" />

        <div className="intro-content display-table">
          <div className="table-cell">
            <div className="container">
              <h1 className="intro-title mb-4">Ethervue</h1>
              <p className="intro-subtitle">
                <strong className="text-slider">
                  <Typed
                    strings={["Embracing Excellence Through Innovation."]}
                    typeSpeed={100}
                    backDelay={1100}
                    backSpeed={30}
                    loop
                  />
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;
